import { Cashback } from '../Cashback'

const HomeLys = props => {
  return (
    <>
      <Cashback {...props} />
    </>
  )
}

export default HomeLys
